import Handover from '../Handover'
import WebSDK from '../Verifai'

const version = '__VERIFAI_VERSION__'
const build = '__VERIFAI_BUILD__'

export default WebSDK
export { WebSDK, Handover, version, build }
